import { useListQuery } from './useListQuery';

export function useApplicationsList(page: number, limit: number) {
  return useListQuery(page, limit, '/application-version', 'applications');
}
